<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [xaxis]="chartOptions.xaxis!"
        [dataLabels]="chartOptions.dataLabels!"
        [grid]="chartOptions.grid!"
        [yaxis]="chartOptions.yaxis!"
        [stroke]="chartOptions.stroke!"
        [title]="chartOptions.title!"
        [colors]="chartOptions.colors!"
    ></apx-chart>
</div>